import axios from "axios";

const axiosAuth = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000",
});

axiosAuth.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    console.log("🔐 Attaching token to request:", token ? token.substring(0, 20) + "..." : "No token");
    console.log("🌐 Request URL:", config.baseURL + config.url);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("🚫 No token found in localStorage");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for debugging and token refresh
axiosAuth.interceptors.response.use(
  (response) => {
    console.log("✅ Response received:", response.status, response.statusText);
    return response;
  },
  async (error) => {
    console.error("❌ Response error:", error.message);
    console.error("❌ Error status:", error.response?.status);
    console.error("❌ Error data:", error.response?.data);
    
    const originalRequest = error.config;

    // Handle 401 Unauthorized error with automatic token refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        console.log('🔄 [TOKEN-REFRESH] Token expired, attempting silent refresh...');
        
        // Get current Firebase user and refresh token silently
        const { auth } = await import('../firebase/firebase');
        const user = auth.currentUser;
        
        if (user) {
          // Force refresh the Firebase ID token
          const newToken = await user.getIdToken(true);
          
          // Update localStorage with fresh token
          localStorage.setItem("authToken", newToken);
          console.log('✅ [TOKEN-REFRESH] Token refreshed successfully');
          
          // Update the Authorization header for the retry
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          
          // Retry the original request with the new token
          console.log('🔁 [TOKEN-REFRESH] Retrying original request with fresh token');
          return axiosAuth(originalRequest);
        } else {
          console.warn('⚠️ [TOKEN-REFRESH] No Firebase user found, redirecting to login');
          // No user signed in, redirect to login
          localStorage.removeItem("authToken");
          window.location.href = '/login';
          return Promise.reject(error);
        }
      } catch (refreshError) {
        console.error('❌ [TOKEN-REFRESH] Token refresh failed:', refreshError);
        // Token refresh failed, log out user
        localStorage.removeItem("authToken");
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosAuth;